import { Palette } from '@common/theming/Palette';
import currency from '@common/utility/currency';
import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';
import ProfileAssetHeading from './ProfileAssetHeading';

const LoanDetails: React.FC<AssetBlockProps> = ({ asset }) => {
  if (!asset.loanDetails?.loanAmount || !asset.loanDetails?.assetValue) {
    return null;
  }
  const assetPercentage = ((asset.loanDetails?.loanAmount / asset.loanDetails?.assetValue) * 100).toFixed(0);

  return (
    <div>
      <ProfileAssetHeading heading={asset.loanDetails?.heading} />
      <div style={{ marginTop: 24 }}>
        <div style={{ backgroundColor: Palette.LIGHT_BLUE_GRAY, borderRadius: 20, height: 40 }}>
          <div
            style={{
              alignItems: 'center',
              backgroundColor: Palette.BLACK,
              borderRadius: 20,
              display: 'flex',
              height: 40,
              paddingLeft: 25,
              width: `${assetPercentage}%`,
            }}>
            <TextBlock color={Palette.LIGHT_GRAY} size={16} weight={'bold'}>
              {assetPercentage}
            </TextBlock>
            <TextBlock
              style={{ whiteSpace: 'nowrap' }}
              color={Palette.LIGHT_GRAY}
              size={16}>{` % Loan-to-Value`}</TextBlock>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 24,
            paddingLeft: 25,
            paddingRight: 25,
          }}>
          <div style={{ textAlign: 'left' }}>
            <TextBlock size={16}>
              {currency.format(asset.loanDetails.loanAmount, { maximumFractionDigits: 0 })}
            </TextBlock>
            <TextBlock size={16}>Borrowed</TextBlock>
          </div>
          <div style={{ textAlign: 'right' }}>
            <TextBlock color={Palette.GRAY} size={16}>
              {currency.format(asset.loanDetails.assetValue, { maximumFractionDigits: 0 })}
            </TextBlock>
            <TextBlock color={Palette.GRAY} size={16}>
              Appraised Value
            </TextBlock>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanDetails;
